export default function logout({ id }: { id: string }) {
  return fetch(`${window.graphqlEndpoint}/auth/${id}`, {
    method: 'DELETE',
  }).then((response) => response.json())
}
